// SPDX-License-Identifier: AGPL-3.0-or-later

import type {AvailabilityCheck} from '@app/features/expressions/utils/ExpressionPermissionUtils';
import {useMemo} from 'react';

export function useAccessibleExpressions<T>(
	items: ReadonlyArray<T>,
	getAvailability: (item: T) => AvailabilityCheck,
): Array<T> {
	return useMemo(() => items.filter((item) => getAvailability(item).canUse), [items, getAvailability]);
}
